import { RouteType } from '@/Routes';
import { lazy } from 'react';

const PlanHistory = lazy(() => import('@/pages/plan/histories'));
const PlanReceipt = lazy(() => import('@/pages/plan/receipt'));

const ServerPlan: RouteType[] = [
  { path: '/plan/histories', component: PlanHistory, title: 'プラン購入履歴' },
  { path: '/plan/receipt', component: PlanReceipt, title: '領収書を発行' },
];

export default ServerPlan;
